/* MYOP quick add-to-cart for bestseller cards.
   AJAX-adds the product's default variant, then reuses Dawn's cart
   notification / drawer if present; otherwise updates the cart count.
   Products with multiple variants send the shopper to the PDP to choose. */
(function () {
  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function updateCartBubble() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var bubble = document.querySelector('.cart-count-bubble');
        if (!bubble) {
          // create a simple bubble if the header has a cart link without one
          var icon = document.querySelector('#cart-icon-bubble');
          if (icon && cart.item_count > 0) {
            var wrap = document.createElement('div');
            wrap.className = 'cart-count-bubble';
            var span = document.createElement('span');
            span.setAttribute('aria-hidden', 'true');
            span.textContent = cart.item_count;
            wrap.appendChild(span);
            icon.appendChild(wrap);
          }
        }
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-myop-quickadd]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    // Multi-variant products → let the shopper choose on the PDP
    if (btn.dataset.hasVariants === 'true' && btn.dataset.productUrl) {
      window.location.href = btn.dataset.productUrl;
      return;
    }

    var id = btn.dataset.variantId;
    if (!id || btn.classList.contains('is-loading')) return;

    var original = btn.dataset.label || btn.textContent;
    btn.dataset.label = original;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding…';

    var cartEl = getCartElement();
    var body = { items: [{ id: id, quantity: 1 }] };
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {           // error (e.g. sold out / limit)
          btn.textContent = 'Unavailable';
          btn.classList.remove('is-loading');
        } else {
          // Keep the "Added" state persistent (don't revert to "Add to cart").
          btn.textContent = 'Added ✓';
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          if (cartEl && res.sections && typeof cartEl.renderContents === 'function') {
            try { cartEl.renderContents(res); } catch (err) { updateCartBubble(); }
          } else {
            updateCartBubble();
          }
        }
      })
      .catch(function () {
        btn.textContent = original;
        btn.classList.remove('is-loading');
      });
  });
})();
